import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "@/context/AuthContext";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import ProtectedRoute from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Ventures from "@/pages/Ventures";
import Projects from "@/pages/Projects";
import Journal from "@/pages/Journal";
import JournalArticle from "@/pages/JournalArticle";
import Contact from "@/pages/Contact";
import Press from "@/pages/Press";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
}

function PublicShell({ children }) {
  return (
    <>
      <Nav />
      <main className="min-h-screen">{children}</main>
      <Footer />
    </>
  );
}

function AdminShell({ children }) {
  return <main className="min-h-screen">{children}</main>;
}

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <AuthProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              {/* Admin routes (no public nav/footer) */}
              <Route path="/admin/login" element={<AdminShell><AdminLogin /></AdminShell>} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminShell><AdminDashboard /></AdminShell>
                  </ProtectedRoute>
                }
              />

              {/* Public routes */}
              <Route path="/" element={<PublicShell><Home /></PublicShell>} />
              <Route path="/about" element={<PublicShell><About /></PublicShell>} />
              <Route path="/ventures" element={<PublicShell><Ventures /></PublicShell>} />
              <Route path="/projects" element={<PublicShell><Projects /></PublicShell>} />
              <Route path="/journal" element={<PublicShell><Journal /></PublicShell>} />
              <Route path="/journal/:id" element={<PublicShell><JournalArticle /></PublicShell>} />
              <Route path="/contact" element={<PublicShell><Contact /></PublicShell>} />
              <Route path="/press" element={<PublicShell><Press /></PublicShell>} />
              <Route path="/press-kit" element={<PublicShell><Press /></PublicShell>} />
              <Route path="*" element={<PublicShell><Home /></PublicShell>} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
